import SelectedCountIcon from './component'

export default SelectedCountIcon
